










import { Component, Vue, Prop } from 'vue-property-decorator';

@Component
export default class FullScreenLoader extends Vue {
    @Prop({ default: false }) public logoSpinner: boolean;

    public withBox: boolean = false;

    constructor() {
        super();
    }
}
